import React, { createContext, useContext } from "react";
import { useSearchParams } from "react-router-dom";

const PricingModalContext = createContext();

export const usePricingModal = () => useContext(PricingModalContext);

export const PricingModalProvider = ({ children }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const isPricingModalOpen = searchParams.get("modal") === "pricing";

  const showPricingModal = () =>
    setSearchParams((prev) => { prev.set("modal", "pricing"); return prev; }, { replace: false });

  const hidePricingModal = () =>
    setSearchParams((prev) => { prev.delete("modal"); return prev; }, { replace: true });

  return (
    <PricingModalContext.Provider value={{ isPricingModalOpen, showPricingModal, hidePricingModal }}>
      {children}
    </PricingModalContext.Provider>
  );
};
